import React from 'react';
import './css/home.css';

import Prevention from './images/coronavirus.jpg';
import {NavLink} from 'react-router-dom';

const Home = () =>{

	return(
		<>
		
		<div className="homeBackground">
			<section className="directLink">
				<h3>Welcome to Covid Portal</h3>
				<div>
					<h1>DO CHECK NEARBY CASES OF COVID</h1>
					<h1 className="change_content"> </h1>
				</div>	
				
				<p>"Here you can check live cases of COVID-19, Just at one Go"</p>
				<NavLink to='/statewise' className="btnone">Cases</NavLink>
				<NavLink to="/vaccination" className="btntwo">Vaccination</NavLink>
			</section>
			
		</div>
		<img src={Prevention} alt=" " className="prevention" />

		
		</>
		);
}
export default Home;